import type { FaireProductEntity } from "../../entity_types/product";

export const p_u2zvc2wa2u: FaireProductEntity = {
  token: "p_u2zvc2wa2u",
  type: "product",
  name: "Shell Napkin Ring",
  brandToken: "b_rz9qg9uuan",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/ff9d52e33a3a9b34d493296705bcf6775ca89b8ae204c41f6051a757076471e3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6813d58be0e5cab93c56cc1b774031e9979859777a314f0ffcdb3f94fbef9f4.png",
    "https://cdn.faire.com/fastly/e2645e96f6283619012997615277522f1af8b2461336129e3140cd0fe79bce5d.jpeg",
  ],
  priceDollars: 11,
  description:
    "Stunning and unique Iraca palm napkin rings, handmade by women artisans from Nariño, Colombia. Using a traditional weaving technique from the region, they are a work of art that will bring the ultimate touch of boho chic to your table. All of our items are 100% handmade from natural fibers. Please allow for any color and sizing variations, or natural imperfections created during the hand making process.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.745Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
